import { render, staticRenderFns } from "./PopupImportResultComponent.vue?vue&type=template&id=0177b512"
import script from "./PopupImportResultComponent.vue?vue&type=script&lang=js"
export * from "./PopupImportResultComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports